import { useState } from "react";
import SponsoredPost from "../home/SponsoredPost";
import NormalPost from "../home/NormalPost";
import CompanyPost from "../home/CompanyPost";
import { BookmarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import MainButton from "./MainButton";
import { useNavigate } from "react-router-dom";
const PostsBase = ({ posts }) => {
  // console.log(posts)
  const { i18n, t } = useTranslation();
  const navigate = useNavigate()
  if (!posts || posts.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center max-w-2xl mx-auto space-y-4 text-center text-gray-300">
        <div className="w-full px-4 py-6 space-y-4 overflow-hidden text-center duration-300 border bg-bg-light-secondary border-border-light rounded-xl dark:bg-bg-dark-secondary dark:border-border-dark">
          {/* <BookmarkIcon className="w-16 h-16 text-[#80B39D] mx-auto" /> */}
          <h2 className="text-xl font-semibold text-black dark:text-white">
            {t("posts.noPostsYet")}
          </h2>
          <p className="text-gray-400">
            {t("posts.description")}
          </p>
          {navigate && (
            <MainButton onClick={() => navigate("/")}>
              {t("posts.browseFeed")}
            </MainButton>
          )}
        </div>
      </div>
    );
  }


  return (
    <div className="max-w-2xl mx-auto space-y-4">
      {/* Posts */}
      {posts?.map((post) =>
        post?.type === "ads" ? (
          <SponsoredPost
            key={post?.id}
            post={post}
          />
        ) : post?.isCompany ? (
          <CompanyPost
            key={post?.id}
            post={post}
          />
        ) : (
          <NormalPost
            key={post?.id}
            post={post}
          />
        ),
      )}
    </div>
  );
};

export default PostsBase;
